import { ZAttrMeta } from "src/business/attribute";
import { ZSpecCommon } from "src/business/specification";

import { AttrVisitor, AttrVisitorCtx } from "./AttrVisitor";

export const walkAttrsInSpecs = (
  specs: ZSpecCommon[],
  visitor: AttrVisitor,
) => {
  specs.forEach((spec) => {
    const ctx: AttrVisitorCtx = { spec };
    spec.definition?.attributes?.forEach((a) => walkAttr(a, visitor, ctx));
  });
};

export const walkAttr = (
  attr: ZAttrMeta,
  visitor: AttrVisitor,
  ctx: AttrVisitorCtx,
) => {
  if (visitor.isSkip?.(attr, ctx)) {
    return;
  }
  visitor.onEach?.(attr, ctx);
  const { type } = attr;
  if (type.name !== "list") {
    visitor.onLeaf?.(attr, ctx);
  } else {
    visitor.onEnter?.(attr, type, ctx);
    type.fields?.forEach((field) => {
      const fieldCtx: AttrVisitorCtx = {
        ...ctx,
        owners: [attr, ...(ctx.owners ?? [])],
      };
      walkAttr(field, visitor, fieldCtx);
    });
    visitor.onLeave?.(attr, type, ctx);
  }
};
